
import Http from 'Api/http';
import { BACKEND_URL_QUOTATION } from 'Config/routes';
import { quotationFromDto } from 'Redux/actions/globalQuotation/dtos';

/**
 * Consulta una cotización individual :)
 */
const getIndividualQuotation = (quotationId) => new Promise((resolve, reject) => {
  new Http({
    full_url: `${BACKEND_URL_QUOTATION}${quotationId}/`,
    method: 'GET',
  }).fetch({
    success: response => resolve(quotationFromDto(response)),
    error: reject,
  });
});

export default getIndividualQuotation;
